import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import { Grid } from "@mantine/core";
import { Control, Controller } from "react-hook-form";
import {
  REGISTRATION_COMPANY_TYPES,
  RegisterCompanyFormInput,
} from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import SelectCompanyType from "@/components/molecules/SelectInputs/SelectCompanyType";

interface CompanyTypeProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const CompanyType: React.FC<CompanyTypeProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading" mt={20}>
        {t("registerCompany:companyType.title")}
      </Text>
      <Grid>
        {/*<Grid.Col span={1} pr={0} mr={0}>*/}
        {/*<SVGAsset name="circle-questionmark" />*/}
        {/*</Grid.Col>*/}
        {/*<Grid.Col span={10} pl={0} ml={0}>*/}
        {/*  <Text size="sm" color="secondary">*/}
        {/*  </Text>*/}
        {/*</Grid.Col>*/}
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Controller
          name="partialCompany.companyType"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <SelectCompanyType
              data-testid="company-type-select"
              required
              showAdminOption={false}
              allowedTypes={REGISTRATION_COMPANY_TYPES}
              label={t("registerCompany:companyType.companyType")}
              onChange={onChange}
              value={value}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default CompanyType;
